import { render, staticRenderFns } from "./ClienteUpdate.vue?vue&type=template&id=eb9db272"
import script from "./ClienteUpdate.vue?vue&type=script&lang=js"
export * from "./ClienteUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports